import { useMemo } from 'react';
import { TrendUpIcon } from '@/components/icons';

import { useActiveSubscribers } from '@/lib/api/hooks/subscriber';

import { Loader } from '@/components/ui/Loader';


const Subscribers = () => {

    // Fetch active subscribers
  const { data: subscribersData, isLoading: isLoadingSubscribers } = useActiveSubscribers();

  // Calculate subscriber stats
  const subscriberStats = useMemo(() => {
    const subscribers = subscribersData?.data || [];
    const total = subscribers.length;

    // Calculate growth (last 30 days)
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

    // const recentSubscribers = [].filter((sub: { dateJoined: string }) => {
    //   const joinDate = new Date(sub.dateJoined);
    //   return joinDate >= thirtyDaysAgo;
    // });

       const recentSubscribers = Array.isArray(subscribers) && subscribers.length > 0 ? subscribers.filter((sub: { dateJoined: string }) => {
      const joinDate = new Date(sub.dateJoined);
      return joinDate >= thirtyDaysAgo;
    }) : [];

    return {
      total,
      growth: recentSubscribers.length
    };
  }, [subscribersData]);

  return (
        <div className="rounded-lg flex flex-col border border-gray p-4 gap-2 h-full">
          <p className="text-sm font-medium text-gray-600">
    Subscribers
  </p>
            {isLoadingSubscribers ? (
              <div className="flex items-center justify-center py-4">
                <Loader size="sm" variant="wine" />
              </div>
            ) : (
              <div className="flex flex-col gap-2">
                <p className="text-3xl font-semibold text-gray-800">{subscriberStats.total}</p>
                {subscriberStats.growth > 0 && (
                  <div className="flex items-center gap-1 text-xs font-medium w-fit text-green-600 bg-green-50 rounded-full px-4 py-2">
                    <TrendUpIcon className="w-3 h-3" />
                    {subscriberStats.growth} over the last 30 days
                  </div>
                )}
              </div>
            )}
          </div>
  )
}

export default Subscribers